import React, { type ChangeEvent, type KeyboardEvent } from "react";
import { Input } from "src/components/Input/Input.tsx";
import { BaseInputAdornment } from "src/components/BaseInput/BaseInputAdornment.tsx";

export const SearchBar = ({
  placeholder,
  searchValue,
  onReset,
  onChange,
  onArrowDown,
  onEnter,
}: {
  placeholder?: string;
  searchValue?: string;
  onReset?: () => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onArrowDown?: () => void;
  onEnter?: () => void;
}) => {
  const handleKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    // do not propagate key up event to 'list navigation' key up handler
  };
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    // do not propagate key down event to 'list navigation' key down handler
    if (e.key === "ArrowDown") {
      e.preventDefault();
      onArrowDown?.();
    }
    if (e.key === "Enter") {
      onEnter?.();
    }
  };

  return (
    <Input
      placeholder={placeholder}
      onKeyUp={handleKeyUp}
      onKeyDown={handleKeyDown}
      startAdornment={
        <BaseInputAdornment>
          <i className="icon-15-search" />
        </BaseInputAdornment>
      }
      endAdornment={
        searchValue && (
          <BaseInputAdornment isAction={true} onClick={onReset}>
            <i className="icon-15-clear_x" />
          </BaseInputAdornment>
        )
      }
      onChange={onChange}
      value={searchValue}
    />
  );
};
